const HearthstoneServerModel = [
  {
    id: 1,
    title: 'Americas',
  },
  {
    id: 2,
    title: 'Europe',
  },
  {
    id: 3,
    title: 'Asia',
  },
];
// eslint-disable-next-line import/prefer-default-export
export { HearthstoneServerModel };
